var _effectorFileName = "/builds/gmini/front-chm-api-sdk/src/assigneeSource.enum.ts";
import * as t from 'io-ts';
export var AssigneeSource;
(function (AssigneeSource) {
  AssigneeSource["ROLE"] = "ROLE";
  AssigneeSource["USER"] = "USER";
  AssigneeSource["COMPANY"] = "COMPANY";
})(AssigneeSource || (AssigneeSource = {}));
export var AssigneeSourceIO = t.union([t.literal(AssigneeSource.ROLE), t.literal(AssigneeSource.USER), t.literal(AssigneeSource.COMPANY)]);